module.exports = __webpack_public_path__ + "static/media/mokuroku-home-gift1.225ee650.svg";